import React from 'react';

import { formatPhoneNumber } from '@savgroup-front-common/core/src/formatters';
import { Field } from '@savgroup-front-common/core/src/molecules/Field';
import { SummarySection } from '@savgroup-front-common/core/src/molecules/SummarySection/SummarySection';

import { useGetFileSummaryNewUi } from '../../FileSummaryNewUi.hooks';
import { messages } from '../../messages';

export const OwnerSectionSummary: React.FC = () => {
  const { data } = useGetFileSummaryNewUi();
  const owner = data?.owner;

  if (!owner || owner.isAnonymous) {
    return <> </>;
  }

  return (
    <SummarySection title={messages.client}>
      {owner.firstname && (
        <Field label={messages.firstName} copy={owner.firstname}>
          {owner.firstname}
        </Field>
      )}
      {owner.lastname && (
        <Field label={messages.lastName} copy={owner.lastname}>
          {owner.lastname}
        </Field>
      )}
      {owner.email && (
        <Field label={messages.email} copy={owner.email}>
          {owner.email}
        </Field>
      )}
      {owner.phone && (
        <Field label={messages.phone} copy={owner.phone}>
          {formatPhoneNumber(owner.phone, owner.address.countryCode)}
        </Field>
      )}
    </SummarySection>
  );
};
